import { FC } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { styled } from '@mui/system';

import { COLORS } from 'src/constants';

const StyledLink = styled(RouterLink)`
  color: ${COLORS.primaryNavy} !important;
`;

interface LinkProps extends RouterLinkProps {
  text: string;
}

const Link: FC<LinkProps> = ({ text, ...props }) => {
  return <StyledLink {...props}>{text}</StyledLink>;
};

export default Link;
